import { render, staticRenderFns } from "./IdeaDisplay.vue?vue&type=template&id=3df3f2a6&scoped=true&"
import script from "./IdeaDisplay.vue?vue&type=script&lang=js&"
export * from "./IdeaDisplay.vue?vue&type=script&lang=js&"
import style0 from "./IdeaDisplay.vue?vue&type=style&index=0&id=3df3f2a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df3f2a6",
  null
  
)

export default component.exports